var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C11.2311 0 8.52431 0.821086 6.22202 2.35943C3.91973 3.89777 2.12532 6.08427 1.06569 8.64243C0.00606596 11.2006 -0.271181 14.0155 0.269012 16.7313C0.809205 19.447 2.14258 21.9416 4.10051 23.8995C6.05845 25.8574 8.55301 27.1908 11.2687 27.731C13.9845 28.2712 16.7994 27.9939 19.3576 26.9343C21.9157 25.8747 24.1022 24.0803 25.6406 21.778C27.1789 19.4757 28 16.7689 28 14C28 10.287 26.525 6.72601 23.8995 4.1005C21.274 1.475 17.713 0 14 0ZM14 6C14.2967 6 14.5867 6.08797 14.8334 6.2528C15.08 6.41762 15.2723 6.65189 15.3858 6.92597C15.4994 7.20006 15.5291 7.50166 15.4712 7.79264C15.4133 8.08361 15.2704 8.35088 15.0607 8.56066C14.8509 8.77044 14.5836 8.9133 14.2926 8.97118C14.0017 9.02906 13.7001 8.99935 13.426 8.88582C13.1519 8.77229 12.9176 8.58003 12.7528 8.33335C12.588 8.08668 12.5 7.79667 12.5 7.5C12.5 7.10218 12.658 6.72064 12.9393 6.43934C13.2207 6.15804 13.6022 6 14 6ZM18 22.125H10V19.875H12.875V14.125H11V11.875H15.125V19.875H18V22.125Z",
    fill: "#434DF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.6941d6f5d4e1cae822e81684aaec2ffa.svg";
export { ForwardRef as ReactComponent };